import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import { DATOS_API } from 'app/auth/auth.datos';
import * as configuracion from 'app/configuracion/login';
import * as $ from 'jquery';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  animations   : fuseAnimations
})
export class LogoutComponent implements OnInit {

  urlAssets = DATOS_API.urlAssets;
  configLogin: any;

  token: string;

  constructor(
    private _fuseConfigService: FuseConfigService,
    private activatedRoute : ActivatedRoute,
    private router: Router
  ) {
    this._fuseConfigService.config = {
        layout: {
            navbar   : {
                hidden: true
            },
            toolbar  : {
                hidden: true
            },
            footer   : {
                hidden: true
            },
            sidepanel: {
                hidden: true
            }
        }
    };

    this.activatedRoute.params.subscribe(params => {
      // console.log(params);
      this.token = params.token;
    });
  }

  ngOnInit() {
    if(localStorage.getItem('customConfig')){
      this.urlAssets = '';
    }
    this.configLogin = configuracion.loginCGO;
    $(document).ready(() => {
      $(".mainDiv").css("background-image","url(" + this.urlAssets + this.configLogin.logoLogout + ")");
    });
    if(!this.token){
      setTimeout(() => {
          this.router.navigate(['/login']);
          // localStorage.clear(); //Limpiar variables de localStorage

      }, 3000);
    }
  }

}
